
const lsRecentKey = 'rr-recent';
const lsRecentMaxLength = 50;

export enum HistoryType {
  Search = "search",
  RepoVisit = "repo-visit"
}

export interface HistoryEntry {
  type: HistoryType;
  text: string;
}

export function clearHistory() {
  // remove item instead of setting an empty array, might be good for fixing possible client side errors
  localStorage.removeItem(lsRecentKey);
}

export function getHistory(): HistoryEntry[] {
  const historyJSONString = localStorage.getItem(lsRecentKey);
  return historyJSONString ? JSON.parse(historyJSONString) : [];
}

export function addToHistory(historyType: HistoryType, text: string): HistoryEntry[] {
  let historyArray = getHistory();

  // see if this selection was already in the array and remove it if so
  const foundIdx = historyArray.findIndex(entry => (entry.text === text && entry.type === historyType));
  if (foundIdx >= 0) { // only splice array when item is found
    historyArray.splice(foundIdx, 1); // 2nd parameter means remove one item only
  }

  // add new entry to array
  const newLength = historyArray.unshift({type: historyType, text});
  if( newLength > lsRecentMaxLength) {
    historyArray = historyArray.slice(0, lsRecentMaxLength);
  }
  localStorage.setItem(lsRecentKey, JSON.stringify(historyArray));
  return historyArray;
}
